import { config } from '@iheartjane/config';
import { Helmet } from 'react-helmet-async';

interface Props {
  description: string;
  /** Boost runtime config option */
  disableMeta?: boolean;
  image?: string;
  isBoostForAll: boolean;
  /** Omit references to Jane on partner hosted sites */
  isPartnerHosted?: boolean;
  /** Omit product detail description for boost4all  */
  isProductDetail?: boolean;
  title: string;
  type?: string;
  url: string;
}

export const OpenGraph = ({
  title,
  description,
  image,
  url,
  type = 'website',
  isBoostForAll,
  isPartnerHosted = false,
  isProductDetail = false,
  disableMeta = false,
}: Props) => {
  const omitDescription = isProductDetail && isBoostForAll;

  /** Note: using fragments prevents the tags from rendering */
  return (
    <Helmet>
      {/** Title and description metadata */}
      {!disableMeta && <meta property="og:title" content={title} />}

      {/** Url & product description metadata is set in boost4all controller https://github.com/janetechinc/iheartjane/blob/b36d47cefe38578e391ecdd3d33addf12bd1f425/api/app/lib/boost/compilation/compile.rb#L35 */}
      {(!disableMeta || !omitDescription) && (
        <meta property="og:description" content={description} />
      )}
      {!isBoostForAll && <meta property="og:url" content={url} />}

      {!disableMeta && <meta name="twitter:title" content={title} />}
      {!disableMeta && (
        <meta name="twitter:description" content={description} />
      )}

      {/** Image metadata, separate from disableMeta check which specifies title & description in config options */}
      {image && <meta property="og:image" content={image} />}
      {image && <meta name="twitter:image" content={image} />}

      {/** Jane references */}
      {!isPartnerHosted && <meta property="og:site_name" content="Jane" />}
      {!isPartnerHosted && (
        <meta property="fb:app_id" content={config.facebookAppId} />
      )}
      {!isPartnerHosted && (
        <meta name="twitter:creator" content="@_iheartjane" />
      )}
      {!isPartnerHosted && <meta name="twitter:site" content="@_iheartjane" />}

      {/** Default metadata */}
      <html
        lang="en"
        prefix="og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# product: http://ogp.me/ns/product#"
      />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="en_US" />
      <meta
        name="twitter:card"
        content={image ? 'summary_large_image' : 'summary'}
      />
    </Helmet>
  );
};
